<div class="search-container">
  <div class="text-search-input-container">
    <input
      #searchInput
      id="searchInput"
      type="text"
      class="input-text"
      [placeholder]="searchTermPlaceholderText"
      [attr.aria-label]="inputTextboxAriaLabel"
      [formControl]="searchFormControl">
    @if (searchInput.value?.length > 0) {
      <button
        class="btn buttonIcon reset-search-button"
        aria-label="Reset Search Criteria"
        type="button"
        tabindex="0"
        (click)="reset()">
        <i class="fa fa-xmark" aria-hidden="true"></i>
      </button>
    }
    <button
      class="input-group-append search-button"
      [attr.aria-label]="inputTextboxAriaLabel"
      type="submit"
      tabindex="0">
      <i class="fa fa-magnifying-glass" aria-hidden="true"></i>
    </button>
  </div>
</div>